/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:11:27
 */
import { Data } from '@/api/axiosFun.js';

class LoginApi {
    static getInstance() {
        if (!this.instance) this.instance = new LoginApi()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 飞书登录
    async feishuLogin (param){
        let url = `/api/auth/feishu`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 登录
    async login (param){
        let url = `/api/user/login`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 注册
    async register (param){
        let url = `/api/user`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 重置密码
    async resetPassword (param,id){
        let url = `/api/user/${id}/pwd`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 校验邮箱
    async vaildEmail (param){
        let url = `/api/user/vali_email`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 获取用户列表
    async getUserList (param){
        let url = `/api/user/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取角色
    async getRole (id){
        let url = `/api/user/${id}/role`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // reqGet
    async reqGet (param){
        let url = `/api/captcha/get`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // reqCheck
    async reqCheck (param){
        let url = `/api/captcha/check`
        let result = await this.getData(url,param,'POST')
        return result
    }

}

export {
    LoginApi
}